import { useEffect, useState } from 'react';
import queryAccountsWithEnvironmentURIs from 'api/Environment/queryAccountsWithEnvironmentURIs';
import useClient from 'api/client';

const useEnvironmentOptions = (environmentLabel: string, uri?: string) => {
    const client = useClient();
    const [options, setOptions] = useState<{ label: string; value: unknown }[]>(
        [],
    );

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                queryAccountsWithEnvironmentURIs(uri || ''),
            );
            if (!response.errors) {
                const accounts = Object.entries(
                    response.data.getEnvironment,
                ).filter(
                    ([key, value]) => key.includes('AccountId') && value !== '',
                );
                const environments = Object.entries(
                    response.data.getEnvironment,
                )
                    .filter(
                        ([key, value]) =>
                            key.includes('EnvironmentUri') && value !== null,
                    )
                    .map(([key, value]) => {
                        const envType = key.replace('EnvironmentUri', '');
                        const updatedEnvType =
                            envType === 'tooling' ? 'tool' : envType;
                        const account = accounts.find(([key]) =>
                            new RegExp(
                                'aws' + updatedEnvType + '*accountid',
                                'i',
                            ).test(key),
                        )?.[1];
                        return {
                            label: `${environmentLabel} (${envType}) - ${account}`,
                            value: value,
                        };
                    });
                setOptions(environments);
            }
        };
        fetchData();
    }, [uri, environmentLabel, client]);

    return options;
};

export default useEnvironmentOptions;
